export const kgMeterMinBandFactor = 0.975;

export const resolveEffectiveMeterPerKg = (meterPerKg, meterPerKgMin) => {
  if (meterPerKgMin != null) {
    const minRatio = Number(meterPerKgMin);
    if (Number.isFinite(minRatio) && minRatio > 0) return minRatio;
  }

  const baseRatio = Number(meterPerKg);
  if (!Number.isFinite(baseRatio) || baseRatio <= 0) return null;

  return baseRatio * kgMeterMinBandFactor;
};

export const roundMeterDownTo5 = (rawMeter) => {
  const value = Number(rawMeter);
  if (!Number.isFinite(value) || value <= 0) return 0;
  return Math.floor(value / 5) * 5;
};

export const convertKgToMeter = (kg, meterPerKg, meterPerKgMin) => {
  const effectiveRatio = resolveEffectiveMeterPerKg(meterPerKg, meterPerKgMin);
  if (!effectiveRatio) return null;

  const rawMeter = Number(kg) * effectiveRatio;
  return roundMeterDownTo5(rawMeter);
};
